import { Router } from '@angular/router';
import { SessionModel } from './../../../session/entities/sessionModel';
import { SessionService } from './../../../session/session.service';
import { environment } from './../../../../environments/environment';
import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { AbstractBefreiungService } from './abstract-befreiung.service';
import { BefreiungErgebnis } from './../entities/befreiungErgebnis';
import { BefreiungAnfrage } from './../entities/befreiungAnfrage';
import { kvNummerIsValid } from '../kvNummerIsValid';
import { getBefreiungError } from './befreiungError';
import { AbstractSessionService } from '../../../session/abstract-session.service';
import { Einwilligung } from '../einwilligung';

@Injectable()
export class BefreiungService implements AbstractBefreiungService {

  constructor(private http: HttpClient, private sessionService: AbstractSessionService, private router: Router ) {}

  getBefreiung(kvNummer: string, einwilligung: Einwilligung): Promise<BefreiungErgebnis> {
    if (!kvNummerIsValid(kvNummer)) {
      return Promise.reject('Ungültige KV-Nummer ' + kvNummer);
    }

    const url = environment.apiBaseUrl + `befreiung`;
    var befreiungAnfrage = new BefreiungAnfrage(kvNummer, Einwilligung[einwilligung]);
    return this.sessionService.getSession()
               .then( session => this.getBefreiungRequest(url, befreiungAnfrage, session));
  }

  private getBefreiungRequest(url: string, befreiungAnfrage: BefreiungAnfrage, session: SessionModel): Promise<BefreiungErgebnis> {

    const headers = new HttpHeaders()
        .set('authorization', 'Bearer ' + session.token )
        .set('Content-Type', 'application/json')
        .set('Accept', 'application/json');
    
    const promise = new Promise<BefreiungErgebnis>((resolve, reject) => {
      this.http.post<BefreiungErgebnis>(url, befreiungAnfrage, {headers: headers})
          .subscribe( (bef: BefreiungErgebnis) => {
            resolve(bef);
          },
        (err) => {
          if (err && err.status === 401) {
            console.error(err);
            this.sessionService.logout();
          }
          reject(getBefreiungError(err));
        });
      });
      return promise;
  }

}



// WEBPACK FOOTER //
// ./src/app/befreiung/shared/services/befreiungService.ts